import React from 'react'
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';

import abilityBuild from '../../shared/CASL/appAbility';
import { checkRoles } from '../../hoc/CheckRoles';
import { RoleContext } from '../../shared/enums';
import { RootState } from '../../store';

import { CommandBar, DefaultButton, Dialog, DialogFooter, DialogType, IButtonProps, ICommandBarItemProps, ICommandBarStyles, IDialogContentProps, IPivotStyles, Label, mergeStyleSets, Pivot, PivotItem, PrimaryButton, Icon } from '@fluentui/react';
import { connect, ConnectedProps } from 'react-redux';
import { IFascicolo } from '../../shared/interfaces';
import { subject, Unsubscribe } from '@casl/ability';
import fascicoliService from '../../services/fascicoli.service';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import AddEditFascicoloNode from './AddEditFascicoloNode';
import FascicoliTree from './FascicoliTree';
import StoriaFascicolo from './StoriaFascicolo';
import DettagliFascicolo from './DettagliFascicolo';
import ErrorUtilities from '../../shared/Utilities/errorUtilities';
import { toastRef } from '../Layout/Layout';

const queryString = require('query-string');

const classNames = mergeStyleSets({
    overFlowHidden: {
        overflow: 'hidden'
    },
    detailsListRow: {
        '.ms-DetailsRow-check': {
            height: '100%',
            width: 36
        },
        '.ms-DetailsRow-fields .ms-DetailsRow-cell': {
            paddingLeft: 0

        }
    }
});

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' },
};
const pivotBarStyles: Partial<IPivotStyles> = {

    root: { padding: '0 24px' },
    itemContainer: { overflow: 'hidden', height: '100%' }
};

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
    arxeiaConfigurations: state.sessionReducer.arxeiaConfigurations,
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface FascicoliProps {

}

type Props = FascicoliProps & RouteComponentProps & PropsFromRedux;

export interface FascicoliState {
    commandBarItems: ICommandBarItemProps[],
    selectedFascicoloNode?: IFascicolo,
    selectedFascicoloNodeKey?: string,
    lateralPanelIsOpen: boolean,
    confirmDialogIsOpen: boolean,
    confirmDialogContentProps: IDialogContentProps,
    loadingFascicoli: boolean
    forceFascicoliTreeRefresh: boolean
    lateralPanelBodyContent: Function,
    lateralPanelSubmitFunction: Function,
    confirmDialogSubmitFunction: Function,
}


class Fascicoli extends React.Component<Props, FascicoliState> {
    unsubscribeFromAbility: Unsubscribe = () => { };

    constructor(props) {
        super(props);

        this.state = {
            commandBarItems: [],
            lateralPanelIsOpen: false,
            lateralPanelBodyContent: () => { },
            lateralPanelSubmitFunction: () => { },
            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogSubmitFunction: () => { },
            loadingFascicoli: false,
            forceFascicoliTreeRefresh: false
        }

    }

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            const parsedQueryString = queryString.parse(this.props.location.search);
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

            let { history } = this.props;

            let fascicoloCheckRuolo: Partial<IFascicolo> = { uorId: uorId };

            if (abilityBuild.cannot('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))) {
                history.push({ pathname: '/notfound' });

            }

            if (abilityBuild.can('read', subject('IFascicolo', fascicoloCheckRuolo))) {
                this.updateCommandBarItems();
            }
            else {
                history.push({ pathname: '/unauthorized' });
            }
        });


    }

    componentDidUpdate(oldProps: Props, oldState: FascicoliState) {
        if (oldProps.currentAoo !== this.props.currentAoo ||
            oldState.selectedFascicoloNode !== this.state.selectedFascicoloNode) {
            this.updateCommandBarItems();


        }
    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
    }


    updateCommandBarItems = () => {
        let { selectedFascicoloNode } = this.state;
        let newCommandBarItems: ICommandBarItemProps[] = [];
        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))
            && abilityBuild.can('create', 'IFascicolo')) {
            newCommandBarItems.push(
                {
                    key: 'addFascicoloNode',
                    iconProps: { iconName: 'Add' },
                    text: 'Aggiungi fascicolo',
                    onClick: this.addFascicoloNodeHandler
                });
        }

        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))
            && abilityBuild.can('read', 'IFascicolo') && selectedFascicoloNode) {
            newCommandBarItems.push(
                {
                    key: 'protocolliFascicolo',
                    iconProps: { iconName: 'Documentation' },
                    text: 'Protocolli',
                    onClick: (event) => this.commandBarNavigateItemHandler(event, {
                        url: `/${this.props.currentAoo?.id}/fascicoli/${selectedFascicoloNode!.id}`
                    })
                },
                {
                    key: 'storiaFascicolo',
                    iconProps: { iconName: 'FullHistory' },
                    text: 'Storia',
                    onClick: this.getStoriaFascicoloHandler
                });
        }

        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))
            && abilityBuild.can('update', 'IFascicolo') && selectedFascicoloNode
            && !selectedFascicoloNode.dataChiusura && selectedFascicoloNode.idPdVConservazione === undefined) {
            newCommandBarItems.push(
                {
                    key: 'editFascicoloNode',
                    iconProps: { iconName: 'Edit' },
                    text: 'Modifica',
                    onClick: this.editFascicoloNodeHandler
                },
                {
                    key: 'chiudiFascicoloNode',
                    iconProps: { iconName: 'Lock' },
                    text: 'Chiudi',
                    onClick: this.closeFascicoloHandler
                });
        }
        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))
            && abilityBuild.can('update', 'IFascicolo') && selectedFascicoloNode
            && selectedFascicoloNode.dataChiusura !== undefined) {
            newCommandBarItems.push(
                {
                    key: 'riapriFascicoloNode',
                    iconProps: { iconName: 'Unlock' },
                    text: 'Riapri',
                    onClick: this.openFascicoloNodeHandler
                });
        }
        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))
            && abilityBuild.can('delete', 'IFascicolo') && selectedFascicoloNode) {
            newCommandBarItems.push({
                key: 'deleteFascicoloNode',
                iconProps: { iconName: 'Delete' },
                text: 'Elimina',
                onClick: this.deleteFascicoloNodeHandler
            });
        }
        this.setState({ commandBarItems: newCommandBarItems });

    }

    commandBarNavigateItemHandler = (ev: any, item: any) => {
        ev.preventDefault();
        if (item !== (null || undefined) && item.url !== (null || undefined)) {
            this.props.history.push({ pathname: item.url, search: this.props.location.search });
        }
    }

    // Click sul button della commandbar - "nuovo fascicolo"
    addFascicoloNodeHandler = () => {
        if (this.state.selectedFascicoloNode && this.state.selectedFascicoloNode.dataChiusura !== undefined) {
            toastRef.current?.show({
                severity: 'warn',
                summary: 'Attenzione',
                detail: `Non è possibile creare un fascicolo sotto un fascicolo chiuso`,
                life: 5000
            });
        } else {
            this.setState(
                {
                    lateralPanelIsOpen: true,
                    lateralPanelBodyContent: () => <AddEditFascicoloNode
                        panelIsOpen={this.state.lateralPanelIsOpen}
                        panelHeaderText='Nuovo fascicolo'
                        loading={false}
                        selectedFascicoloNode={this.state.selectedFascicoloNode}
                        onSubmit={this.addFascicoloNodeLateralPanelSubmit}
                        onDismiss={this.dismissLateralPanel}
                        panelIsEdit={false}
                    />
                }
            );
        }
    }

    // Click su salva del panel laterale
    addFascicoloNodeLateralPanelSubmit = (fascicoloItem: Partial<IFascicolo>) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi creare un nuovo fascicolo?',

            },
            confirmDialogSubmitFunction: () => { this.addFascicoloNodeConfirmDialogSubmit(fascicoloItem) }
        })
    }

    // Click su conferma del confirm dialog
    addFascicoloNodeConfirmDialogSubmit = (fascicoloNode: Partial<IFascicolo>) => {
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;
        let { currentAoo } = this.props;

        if (currentAoo && uorId) {
            this.setState({ loadingFascicoli: true });
            let { forceFascicoliTreeRefresh } = this.state;


            fascicoliService.addFascicolo(currentAoo.id, uorId, fascicoloNode)
                .then(result => {
                    this.setState({ forceFascicoliTreeRefresh: !forceFascicoliTreeRefresh });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: fascicoloNode.descrizione,
                        detail: `Fascicolo creato correttamente`,
                        life: 5000
                    });

                })
                .catch(error => {

                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: fascicoloNode.descrizione,
                            detail: 'Non è stato possibile creare il fascicolo',
                            life: 5000
                        });
                    }

                    this.setState({ loadingFascicoli: false });

                });

            this.setState({ confirmDialogIsOpen: false, loadingFascicoli: true })

        }
    }


    // Click sul button della commandbar -  "storia"
    getStoriaFascicoloHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <StoriaFascicolo
                    selectedFascicoloNode={this.state.selectedFascicoloNode}
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText="Storia del fascicolo"
                    onDismiss={this.dismissLateralPanel}
                />
            }
        );
    }

    // Click sul button della commandbar - "Chiudi"
    closeFascicoloHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: false,
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: `Vuoi chiudere il fascicolo?`,
                },
                confirmDialogSubmitFunction: () => { this.closeFascicoloNodeConfirmDialogSubmit() }
            });
    }

    // Click sulla conferma del dialog - "Chiudi"
    closeFascicoloNodeConfirmDialogSubmit = () => {
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;


        if (this.props.currentAoo && uorId && this.state.selectedFascicoloNode) {
            let fascicolo: IFascicolo = { ...this.state.selectedFascicoloNode };
            let { forceFascicoliTreeRefresh } = this.state;

            if (fascicolo) {
                fascicoliService.chiudiFascicolo(this.props.currentAoo.id, uorId, fascicolo.id)
                    .then(result => {

                        toastRef.current?.show({
                            severity: 'info',
                            summary: fascicolo.descrizione,
                            detail: 'Il Fascicolo è stato chiuso correttamente',
                            life: 5000
                        })
                        this.setState({ forceFascicoliTreeRefresh: !forceFascicoliTreeRefresh })
                        this.updateCommandBarItems();
                    })
                    .catch(error => {
                        if (!error.isErrorShown) {
                            toastRef.current?.show({
                                severity: 'error',
                                summary: "Attenzione",
                                detail: 'Non è stato possibile chiudere il fascicolo',
                                life: 5000
                            });
                        }
                    })
            }
            this.setState({ confirmDialogIsOpen: false });

        }
    }

    //Click sul button della commandbar - "Riapri"
    openFascicoloNodeHandler = () => {
        if (this.state.selectedFascicoloNode && this.state.selectedFascicoloNode.idPdVConservazione) {
            toastRef.current?.show({
                severity: 'warn',
                summary: 'Attenzione',
                detail: `Non è possibile riaprire un fascicolo andato in conservazione`,
                life: 5000
            });
        } else {

            this.setState(
                {
                    lateralPanelIsOpen: false,
                    confirmDialogIsOpen: true,
                    confirmDialogContentProps: {
                        type: DialogType.normal,
                        title: 'Conferma',
                        closeButtonAriaLabel: 'Close',
                        subText: `Vuoi riaprire il fascicolo?`,
                    },
                    confirmDialogSubmitFunction: () => { this.openFascicoloNodeConfirmDialogSubmit() }
                });
        }
    }
    //Click sulla conferma del dialog - "Riapri"
    openFascicoloNodeConfirmDialogSubmit = () => {
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;


        if (this.props.currentAoo && uorId && this.state.selectedFascicoloNode?.dataChiusura !== undefined) {
            let fascicolo: IFascicolo = { ...this.state.selectedFascicoloNode };
            let { forceFascicoliTreeRefresh } = this.state;

            if (fascicolo) {
                fascicoliService.riapriFascicolo(this.props.currentAoo.id, uorId, fascicolo.id)
                    .then(result => {

                        toastRef.current?.show({
                            severity: 'info',
                            summary: fascicolo.descrizione,
                            detail: 'Il Fascicolo è stato riaperto correttamente',
                            life: 5000
                        })
                        this.setState({ forceFascicoliTreeRefresh: !forceFascicoliTreeRefresh });
                        this.updateCommandBarItems();
                    })
                    .catch(error => {
                        if (!error.isErrorShown) {
                            toastRef.current?.show({
                                severity: 'error',
                                summary: "Attenzione",
                                detail: 'Non è stato possibile riaprire il fascicolo',
                                life: 5000
                            });
                        }
                    })
            }
            this.setState({ confirmDialogIsOpen: false });

        }
    }

    //Click sul button della commandbar - 'Elimina'
    deleteFascicoloNodeHandler = () => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: `Vuoi rimuovere il fascicolo?`,
            },
            confirmDialogSubmitFunction: () => { this.deleteFascicoloNodeConfirmDialogSubmit() }
        });
    }

    // Click su conferma del confirm dialog - 'Elimina'
    deleteFascicoloNodeConfirmDialogSubmit = () => {
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (this.props.currentAoo && uorId && this.state.selectedFascicoloNode) {
            let fascicolo: IFascicolo = { ...this.state.selectedFascicoloNode };
            let { forceFascicoliTreeRefresh } = this.state

            if (fascicolo.id) {
                fascicoliService.deleteFascicolo(this.props.currentAoo.id, uorId, fascicolo.id)
                    .then(result => {
                        this.setState({ forceFascicoliTreeRefresh: !forceFascicoliTreeRefresh });
                        toastRef.current?.show({
                            severity: 'info',
                            summary: fascicolo.descrizione,
                            detail: 'Fascicolo eliminato correttamente',
                            life: 5000
                        })

                    })
                    .catch(error => {
                        if (!error.isErrorShown) {
                            toastRef.current?.show({
                                severity: 'error',
                                summary: "Attenzione",
                                detail: 'Non è stato possibile eliminare il fascicolo',
                                life: 5000
                            });
                        }
                    });
            }
            this.setState({ confirmDialogIsOpen: false, selectedFascicoloNode: undefined });
        }
    }

    // Click sul button della commandbar - 'Modifica'
    editFascicoloNodeHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditFascicoloNode
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Modifica fascicolo'
                    loading={false}
                    selectedFascicoloNode={this.state.selectedFascicoloNode}
                    onSubmit={this.editFascicoloNodeLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsEdit={true}
                />
            }
        );
    }

    // Click su salva del panel laterale - 'Modifica'
    editFascicoloNodeLateralPanelSubmit = (fascicoloNode: Partial<IFascicolo>) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: `Vuoi modificare il fascicolo?`,

            },
            confirmDialogSubmitFunction: () => { this.editFascicoloNodeConfirmDialogSubmit(fascicoloNode) }
        })
    }

    // Click su conferma del confirm dialog - 'Modifica'
    editFascicoloNodeConfirmDialogSubmit = (fascicoloNode: Partial<IFascicolo>) => {
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (this.props.currentAoo && uorId && this.state.selectedFascicoloNode) {
            let fascicolo: IFascicolo = { ...this.state.selectedFascicoloNode };
            let currentAoo = { ...this.props.currentAoo };

            let { forceFascicoliTreeRefresh } = this.state;

            let responsabile = fascicoloNode.responsabile;
            let description = fascicoloNode.descrizione;

            let patchJson = [{
                op: "add",
                path: "/responsabile",
                value: responsabile
            },
            {
                op: "add",
                path: "/descrizione",
                value: description
            }]

            if (fascicolo.id) {

                fascicoliService.updateFascicolo(currentAoo.id, uorId, fascicolo.id, patchJson)
                    .then(result => {
                        this.setState({ forceFascicoliTreeRefresh: !forceFascicoliTreeRefresh });

                        toastRef.current?.show({
                            severity: 'info',
                            summary: fascicoloNode.descrizione,
                            detail: `Fascicolo aggiornato correttamente`,
                            life: 5000
                        })
                    })
                    .catch(error => {
                        if (!error.isErrorShown) {
                            toastRef.current?.show({
                                severity: 'error',
                                summary: "Attenzione",
                                detail: 'Non è stato possibile aggiornare il fascicolo',
                                life: 5000
                            });
                        }
                    });
            }
            this.setState({ confirmDialogIsOpen: false })
        }
    }

    dismissLateralPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ lateralPanelIsOpen: false })
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }


    onSelectFascicoloHandler = (selected) => {
        let itemKey;
        if (selected) {
            itemKey = selected.id;
        }

        this.setState({
            selectedFascicoloNode: selected,
            selectedFascicoloNodeKey: itemKey
        })
    }


    render() {

        return (
            <React.Fragment>

                {this.state.lateralPanelBodyContent()}

                <Dialog
                    hidden={!this.state.confirmDialogIsOpen}
                    onDismiss={this.dismissConfirmDialog}
                    dialogContentProps={this.state.confirmDialogContentProps}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                        <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                    </DialogFooter>

                </Dialog>

                <div className="filig-plan-component flex flex-column p-nogutter" >

                    {this.state.commandBarItems.length > 0 &&
                        <CommandBar
                            overflowButtonProps={overflowProps}
                            items={this.state.commandBarItems}
                            styles={commandBarStyles}

                        />
                    }
                    {
                        this.props.isMobile
                            // if true
                            ?
                            <div className="filig-plan-content flex flex-row">
                                <Pivot aria-label="Gestione fascicoli" styles={pivotBarStyles} className="flex flex-column filig-plan-pivot-component" >
                                    <PivotItem headerText="Fascicoli" className="filig-plan-pivot-item flex flex-column" >
                                        <div className={"filig-plan-tree col-12 lg:col-7 flex flex-column position-relative " + classNames.overFlowHidden}>
                                            <FascicoliTree
                                                extraCssClass={`flex flex-column position-relative`}
                                                loadingFascicoli={this.state.loadingFascicoli}
                                                forceTreeRefresh={this.state.forceFascicoliTreeRefresh}
                                                selectedFascicoloNode={this.state.selectedFascicoloNode}
                                                onSelectFascicoloHandler={(selected) => this.onSelectFascicoloHandler(selected)}
                                                getProtocolliDiFascicolo={(event) => this.commandBarNavigateItemHandler(event, {
                                                    url: `/${this.props.currentAoo?.id}/fascicoli/${this.state.selectedFascicoloNode!.id}`
                                                })}
                                                getStoriaFascicoloHandler={this.getStoriaFascicoloHandler}
                                                editFascicoloNodeHandler={this.editFascicoloNodeHandler}
                                                closeFascicoloHandler={this.closeFascicoloHandler}
                                                openFascicoloNodeHandler={this.openFascicoloNodeHandler}
                                                deleteFascicoloNodeHandler={this.deleteFascicoloNodeHandler}
                                            />

                                        </div>
                                    </PivotItem>
                                    {
                                        this.state.selectedFascicoloNode &&
                                        <PivotItem headerText="Dettagli del fascicolo" className="flex flex-column" >

                                                <div className={"filig-plan-table col-12 lg:col-5 flex flex-column position-relative " + classNames.overFlowHidden}>
                                                <Label >{`Dettagli del fascicolo`}:</Label>
                                                <div className={`flex flex-column position-relative`}>
                                                    <DettagliFascicolo
                                                        currentFascicolo={this.state.selectedFascicoloNode}
                                                    />
                                                </div>

                                            </div>

                                        </PivotItem>
                                    }
                                </Pivot>
                            </div>

                            //else non mobile
                            : <div className="filig-plan-content flex flex-row p-nogutter">
                                <div className={"filig-plan-tree col-12 lg:col-7 flex flex-column position-relative " + classNames.overFlowHidden}>

                                    <FascicoliTree
                                        extraCssClass={`flex flex-column position-relative`}
                                        loadingFascicoli={this.state.loadingFascicoli}
                                        forceTreeRefresh={this.state.forceFascicoliTreeRefresh}
                                        selectedFascicoloNode={this.state.selectedFascicoloNode}
                                        onSelectFascicoloHandler={(selected) => this.onSelectFascicoloHandler(selected)}
                                        getProtocolliDiFascicolo={(event) => this.commandBarNavigateItemHandler(event, {
                                            url: `/${this.props.currentAoo?.id}/fascicoli/${this.state.selectedFascicoloNode!.id}`
                                        })}
                                        getStoriaFascicoloHandler={this.getStoriaFascicoloHandler}
                                        editFascicoloNodeHandler={this.editFascicoloNodeHandler}
                                        closeFascicoloHandler={this.closeFascicoloHandler}
                                        openFascicoloNodeHandler={this.openFascicoloNodeHandler}
                                        deleteFascicoloNodeHandler={this.deleteFascicoloNodeHandler}
                                    />
                                </div>
                                {this.state.selectedFascicoloNode &&
                                    <div className={"filig-plan-table col-12 lg:col-5 flex flex-column position-relative " + classNames.overFlowHidden}>
                                        <Label >{`Dettagli del fascicolo`}:</Label>
                                        <div className={`flex flex-column position-relative`}>
                                            <DettagliFascicolo
                                                currentFascicolo={this.state.selectedFascicoloNode}
                                            />
                                        </div>

                                    </div>
                                }
                            </div>


                    }
                </div>
            </React.Fragment >

        )
    }
}

export default connector(withRouter(checkRoles(Fascicoli, RoleContext.Uor)));
